export default __webpack_public_path__ + "static/media/dispenser-2.9f7807a5.svg";